import { Routes, Route } from "react-router-dom";
import LoginRedirect from "../MSAL/LoginRedirect";
import { Grid } from "@mui/material";

const PublicRoutes = () => {

    return (
        <Grid
            container
            alignItems="center"
            justifyContent="center"
            xs={12}

            style={{ minHeight: '100vh', }}

        >

            <Grid
                i tem
                xs={12}
                md={8}
               

            >
         

                <Routes>
                    <Route exact path="/" element={<LoginRedirect />} />
                </Routes>
            </Grid>
        </Grid>
    )
};

export default PublicRoutes